import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../axios';
import ProjectCard from './ProjectCard';
import ProjectFilters from './ProjectFilters';
import debounce from "lodash/debounce";
import classes from './Projects.module.css';

const Projects = () => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const [debouncedSearchValue, setDebouncedSearchValue] = useState('');
  const [sortBy, setSortBy] = useState('createdAt');
  const [sortDirection, setSortDirection] = useState('desc');

  const debouncedSetSearch = useMemo(
    () => debounce((value) => {
      setDebouncedSearchValue(value);
    }, 300),
    []
  );

  useEffect(() => {
    debouncedSetSearch(searchValue);
    return () => {
      debouncedSetSearch.cancel();
    };
  }, [searchValue, debouncedSetSearch]);

  useEffect(() => {
    loadProjects();
  }, [debouncedSearchValue, sortBy, sortDirection]);

  const loadProjects = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/projects?search=${debouncedSearchValue}&sortBy=${sortBy}&sortDirection=${sortDirection}`);
      if (response.data && response.data.success && response.data.projects) {
        setProjects(response.data.projects);
      } else {
        setProjects([]);
      }
    } catch (error) {
      console.error('Failed to load projects:', error);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAddProject = () => {
    navigate('/projects/add-project');
  };

  const handleProjectClick = (project) => {
    navigate(`/project/${project._id}`);
  };

  return (
    <div className={classes.projects}>
      <div className={classes.header}>
        <h2 className={classes.title}>Projects</h2>
        <button onClick={handleAddProject} className={classes.addButton}>
          Add
        </button>
      </div>

      <ProjectFilters 
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        sortBy={sortBy}
        setSortBy={setSortBy}
        sortDirection={sortDirection}
        setSortDirection={setSortDirection}
      />

      {loading ? (
        <div className={classes.message}>Loading projects...</div>
      ) : projects.length === 0 ? (
        <div className={classes.message}>No projects found</div>
      ) : (
        <div className={classes.projectsGrid}>
          {projects.map((project) => (
            <ProjectCard
              key={project._id}
              project={project}
              onClick={() => handleProjectClick(project)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Projects;

